import React, { useMemo } from 'react'
import styles from './ModalContent.module.sass'
import { capitalize } from '@material-ui/core';
import PerfectScrollbar from 'react-perfect-scrollbar';
import DisplayableSheet from '../PackageBuilders/MultiPose/DisplayableSheet';
import reviewStyles from '../PackageBuilders/MultiPose/ReviewModal.module.scss';
import Modal from '../PackageBuilders/MultiPose/Modal';

const ModalContent = ({ isOpen, closeModal, selectedPose, handleContinue, option,
                        studentImageUrl, backgroundUrl, imageTypes, price }) => {
  const isClassPhoto = imageType => imageType.name.toLowerCase().includes('class');
  const filter = imageType => !isClassPhoto(imageType);

  const renderButton = () => (
    <button className={styles.continueBtn} onClick={handleContinue}>
      SELECT BACKGROUNDS
    </button>
  )

  const placeholderSheets = useMemo(() => {
    if (!selectedPose) return [];

    return (
      imageTypes.filter(filter).map((imageType) => (
        new Array(imageType.count).fill(null).map(() => ({
          imageType,
          imageTypeId: imageType.id,
          pose: selectedPose,
          poseId: selectedPose.id,
        }))
      )).flat()
    );
  }, [imageTypes, selectedPose]);

  const organizedSheets = useMemo(() => (
    placeholderSheets.reduce((acc, sheet) => {
      if (acc[sheet.imageTypeId]) {
        return { ...acc, [sheet.imageTypeId]: [...acc[sheet.imageTypeId], sheet] };
      }

      return { ...acc, [sheet.imageTypeId]: [sheet] };
    }, {})
  ), [placeholderSheets]);

  return (
    <Modal.Content isOpen={isOpen} className={reviewStyles.content}>
      <div className={styles.body}>
        <div className={styles.headerWrapper}>
          <Modal.Close onClick={closeModal} className={reviewStyles.close}>X</Modal.Close>
        </div>
        <div className={styles.optionHeader}>
          <p className={styles.optionName}>
            {option.name}
          </p>
          <p>{price}</p>
        </div>

        <div>
          {Object.values(organizedSheets).map((sheetCollection, i) => (
            <div key={i} className={reviewStyles.sheetsWrapper}>
              <div className={reviewStyles.sheetsHeader}>
                <div>{capitalize(sheetCollection[0].imageType.name.toLowerCase())}</div>
              </div>
              <PerfectScrollbar>
                <div className={reviewStyles.displayableSheets}>
                  {sheetCollection.map((sheet, j) => (
                    <DisplayableSheet key={j} className={reviewStyles.displayableSheet} sheet={sheet} />
                  ))}
                </div>
              </PerfectScrollbar>
            </div>
          ))}
        </div>
        {renderButton()}
      </div>
    </Modal.Content>
  );
}

export default ModalContent
